'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/stage1.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _selectors = require('@marmalade/account/lib/selectors');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _constants = require('@marmalade/constants');
var _constants2 = _interopRequireDefault(_constants);
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _formNavigation = require('@marmalade/form/lib/components/form-navigation');
var _formNavigation2 = _interopRequireDefault(_formNavigation);
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _grid = require('@marmalade/grid');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _formOptions = require('@marmalade/marker-study/lib/form-options');
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _panel = require('@marmalade/panel');
var _progressBar = require('@marmalade/progress-bar');
var _propTypes = require('@marmalade/prop-types');
var _selectors2 = require('@marmalade/query/lib/selectors');
var _glamorous = require('glamorous');
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _renderIfBroker = require('../render-if-broker');
var _renderIfBroker2 = _interopRequireDefault(_renderIfBroker);
var _constants3 = require('./constants');
var _domain = require('@marmalade/domain');
var _domain2 = _interopRequireDefault(_domain);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var NewStage1 = function (_Component) {
  _inherits(NewStage1, _Component);
  function NewStage1() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, NewStage1);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewStage1.__proto__ || Object.getPrototypeOf(NewStage1)).call.apply(_ref, [this].concat(args))), _this), _this.fetchFormOptions = function () {
      _this.props.getFormOptions('ldi', 'title');
      _this.props.getFormOptions('ldi', 'ownerRelation');
      _this.props.getFormOptions('ldi', 'keptOvernight');
      _this.props.getFormOptions('ldi', 'employmentStatus');
    }, _this.handleSubmit = function (form) {
      _this.props.history.push(_this.props.linkPrefix + '/stage2');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(NewStage1, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchFormOptions();
    }
  }, {
    key: 'render',
    value: function render() {
      var isWhitelabel = this.props.theme.name !== 'Marmalade';
      var Element = this.props.container ? _grid.Container : _react.Fragment;
      if (this.props.getFormOptionsPending) {
        return _react2.default.createElement(_loading2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55
          },
          __self: this
        });
      }
      if (this.props.getFormOptionsErrors) {
        return _react2.default.createElement(Element, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          },
          __self: this
        }, _react2.default.createElement(_message2.default, {
          type: 'error',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 61
          },
          __self: this
        }, 'Sorry, something went wrong, please try again or call us on', ' ', _react2.default.createElement('a', {
          href: 'tel:' + _constants2.default.contact.phone.general,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 63
          },
          __self: this
        }, _constants2.default.contact.phone.general), ' if the problem persists.'), _react2.default.createElement(_glamorous.Div, {
          marginBottom: '1em',
          marginTop: '-.5em',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          },
          __self: this
        }, _react2.default.createElement(_button2.default, {
          block: true,
          onClick: this.fetchFormOptions,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67
          },
          __self: this
        }, 'Try again')));
      }
      return _react2.default.createElement(Element, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76
        },
        __self: this
      }, _react2.default.createElement(_form2.default, {
        id: 'newBusinessStage1',
        handleSubmit: this.handleSubmit,
        preventSubmitOnEnterKey: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        },
        __self: this
      }, _react2.default.createElement(_progressBar.WithStages, {
        newBusinessStages: _constants3.stages,
        active: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78
        },
        __self: this
      }), _react2.default.createElement('h1', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        },
        __self: this
      }, _constants3.stages[0].name), this.props.hasErrors && _react2.default.createElement(_message2.default, {
        type: 'error',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        },
        __self: this
      }, 'There are some errors in the details you provided, please check them carefully and try again.'), _react2.default.createElement(_renderIfBroker2.default, {
        checkboxName: 'broker_stage_1a',
        options: [{
          text: 'These statements have been read to the customer, along with BROKERNAME own FCA statement.',
          value: 'true'
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        },
        __self: this
      }, _react2.default.createElement('ul', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96
        },
        __self: this
      }, _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97
        },
        __self: this
      }, _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        },
        __self: this
      }, 'BROKERNAME'), ' is authorised and regulated by the financial conduct authority.'), _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        },
        __self: this
      }, 'This product is a Marmalade policy underwriter by Ageas Insurance Limited.'))), _react2.default.createElement(_panel.PanelAside, {
        title: 'Apply now for instant cover',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105
        },
        __self: this
      }, 'There are a few important points about ', isWhitelabel ? "Marmalade's" : 'our', ' cover we need to confirm, so you can check that ', isWhitelabel ? 'the' : 'our', ' Learner Insurance policy suits your needs.'), _react2.default.createElement('ul', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: this
      }, _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 111
        },
        __self: this
      }, isWhitelabel ? 'Marmalade' : 'Our', ' Learner Insurance is only suitable for provisional drivers who wish to insure a specified vehicle in which they intend to practise.'), _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      }, 'Learners must be supervised by a qualified driver, aged 25 or over, who has held a full UK driving licence for more than 3 years.'), _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119
        },
        __self: this
      }, isWhitelabel ? "Marmalade's" : 'Our', ' policy acts as a secondary insurance whilst you are driving a car owned or registered by someone else, and is not suitable as main insurance on the car.'), _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        },
        __self: this
      }, 'The vehicle must remain insured by the owner throughout the term of this policy.')), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        },
        __self: this
      }, 'By pressing ', _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127
        },
        __self: this
      }, 'Proceed to Step 2'), ' you are confirming that you have downloaded, read, and understood the', ' ', _react2.default.createElement('a', {
        href: (0, _domain2.default)('api.wearemarmalade') + '/proxy/document.php?product=1&documentType=4&return=download',
        target: '_blank',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129
        },
        __self: this
      }, 'Terms of Business document'))), _react2.default.createElement(_formNavigation2.default, {
        next: {
          submit: true,
          text: 'Proceed to Step 2'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134
        },
        __self: this
      })));
    }
  }]);
  return NewStage1;
}(_react.Component);
NewStage1.propTypes = {
  linkPrefix: _propTypes2.string.isRequired,
  getFormOptions: _propTypes2.func.isRequired,
  history: _propTypes.history.isRequired,
  hasQuoted: _propTypes2.bool.isRequired,
  isLoggedIn: _propTypes2.bool.isRequired,
  container: _propTypes2.bool.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    hasErrors: (0, _formInfo.hasErrors)(state, _constants3.stages[0].formId),
    hasQuoted: !!(0, _selectors2.queries)(state).logId && !!(0, _selectors2.queries)(state).cover && !!(0, _selectors2.queries)(state).policyQuote,
    isLoggedIn: (0, _selectors.isLoggedIn)(state),
    getFormOptionsErrors: (0, _formOptions.getFormOptionsErrors)(state),
    getFormOptionsPending: (0, _formOptions.getFormOptionsPending)(state)
  };
}, {
  getFormOptions: _formOptions.getFormOptions
})((0, _glamorous.withTheme)(NewStage1)));